class HeroBanner extends HTMLElement {
  constructor() {
    super();

    this.passedElement = false;
    this.grid = this.classList.contains("hero-banner--grid");
    this.swipe = this.classList.contains("hero-banner--swipe");

    this.gridPadding = parseFloat(
      window
        .getComputedStyle(document.body)
        .getPropertyValue("--padding-sections-desktop")
        .replace("rem", "")
    );

    if (this.swipe) {
      this.parent = this.closest(".shopify-section");
      this.nextElement = this.parent.nextElementSibling;

      this.nextElement.style.setProperty(
        "min-height",
        this.offsetHeight + "px"
      );
      this.nextElement.style.setProperty(
        "border-top-left-radius",
        this.offsetHeight / 2 + "px"
      );
      this.nextElement.style.setProperty(
        "border-bottom-left-radius",
        this.offsetHeight / 2 + "px"
      );

      this.nextElement.classList.add("shopify-section--swipe-next");
      document.addEventListener("scroll", this.swipeEvent.bind(this));
    } else if (this.grid) {
      document.addEventListener("scroll", this.scrollEvent.bind(this));
    }
  }

  scrollEvent() {
    const visibleAmount = this.getViewPercentage(this) * 0.5;

    if (
      (this.getViewPercentage(this) > 50 && !this.passedElement) ||
      (this.getViewPercentage(this) < 50 && this.passedElement)
    ) {
      this.style.setProperty(
        "padding",
        "calc(var(--padding-sections-desktop) - " + visibleAmount + "px)"
      );
      if (visibleAmount >= this.gridPadding * 10) {
        this.classList.add("hero-banner--full");
      } else {
        this.classList.remove("hero-banner--full");
      }
    } else if (this.getViewPercentage(this) < 50 && !this.passedElement) {
      this.style.setProperty("padding", "var(--padding-sections-desktop)");
      this.classList.remove("hero-banner--full");
    } else if (this.getViewPercentage(this) > 50 && this.passedElement) {
      this.style.setProperty("padding", "0");
      this.classList.add("hero-banner--full");
    }
  }

  swipeEvent() {
    const scrollY = window.pageYOffset;
    const heroHeight = this.offsetHeight;

    const scrollPercent = Math.min(scrollY / heroHeight, 1); // Clamp to 1

    let yOffsetPercentage =
      100 - (window.pageYOffset / this.offsetHeight) * 100;

    if (yOffsetPercentage < 0) {
      yOffsetPercentage = 0;
    }

    let announcementBarHeight = 0;
    if (
      document.querySelector(
        ".shopify-section-group-header-group.announcement-bar-section"
      )
    ) {
      announcementBarHeight = document.querySelector(
        ".shopify-section-group-header-group.announcement-bar-section"
      ).offsetHeight;
    }

    if (yOffsetPercentage > 0) {
      this.style.setProperty(
        "top",
        window.pageYOffset - announcementBarHeight + "px"
      );

      let heightToUse =
        window.pageYOffset > this.nextElement.offsetHeight
          ? this.nextElement.offsetHeight
          : window.pageYOffset;

      if (this.offsetHeight > window.innerHeight) {
        heightToUse = heightToUse - (this.offsetHeight - window.innerHeight);
      }

      const easedRadius =
        scrollPercent < 0.9
          ? this.offsetHeight / 2
          : (this.offsetHeight / 2) * Math.pow(1 - scrollPercent, 4); // Sharp drop-off
      this.nextElement.style.borderTopLeftRadius = `${easedRadius}px`;
      this.nextElement.style.borderBottomLeftRadius = `${easedRadius}px`;

      this.nextElement.style.setProperty(
        "top",
        `calc(${heightToUse - announcementBarHeight}px - ${
          this.offsetHeight
        }px)`
      );
    }

    this.nextElement.style.setProperty("left", yOffsetPercentage + "%");
  }

  getViewPercentage(element) {
    const viewport = {
      top: window.pageYOffset,
      bottom: window.pageYOffset + window.innerHeight,
    };

    const elementBoundingRect = element.getBoundingClientRect();
    const elementPos = {
      top: elementBoundingRect.y + window.pageYOffset,
      bottom:
        elementBoundingRect.y + elementBoundingRect.height + window.pageYOffset,
    };

    if (viewport.top > elementPos.bottom || viewport.bottom < elementPos.top) {
      return 0;
    }

    // Element is fully within viewport
    if (viewport.top < elementPos.top && viewport.bottom > elementPos.bottom) {
      return 100;
    }

    // Element is bigger than the viewport
    if (elementPos.top < viewport.top && elementPos.bottom > viewport.bottom) {
      return 100;
    }

    const elementHeight = elementBoundingRect.height;
    let elementHeightInView = elementHeight;

    if (elementPos.top < viewport.top) {
      elementHeightInView =
        elementHeight - (window.pageYOffset - elementPos.top);
      this.passedElement = true;
    }

    if (elementPos.bottom > viewport.bottom) {
      elementHeightInView =
        elementHeightInView - (elementPos.bottom - viewport.bottom);
      this.passedElement = false;
    }

    const percentageInView = (elementHeightInView / window.innerHeight) * 100;

    return Math.round(percentageInView);
  }
}

customElements.define("hero-banner", HeroBanner);
